export var SavingOperationType;
(function (SavingOperationType) {
    SavingOperationType["WITHDRAW"] = "popup_html_withdraw";
    SavingOperationType["DEPOSIT"] = "popup_html_deposit";
})(SavingOperationType || (SavingOperationType = {}));
